import { useLingui } from '@lingui/react/macro'

import { DialogHeader } from '@/layouts/Dialog'
import { Suspense } from '@/components/ui/Suspense'
import { PmsSteps } from '@/features/pms'

const PmsDialog: React.FC = () => {
  const { t } = useLingui()

  return (
    <div className="flex flex-col p-8">
      <DialogHeader
        title={t`PMS Integration`}
        description={t`Setup the integration with your PMS to sync Rooms, Guests and Stays/Reservations.`}
      />
      <PmsSteps />
    </div>
  )
}

export default function PmsSuspense() {
  return (
    <Suspense isDialog>
      <PmsDialog />
    </Suspense>
  )
}
